import axiosInstance from '../helpers/axiosInstance';

export const getProjectsApi = async (pageNo, searchKey, sort = {}) => {
    let url;
    if (Object.keys(sort).length === 2) {
        url = `staff/purchaseOrder/purchaseOrderProjects?sortField=${sort.sortField}&sortMethod=${sort.sortType}&page=${pageNo}&searchKey=${searchKey}`;
    } else {
        url = searchKey !== undefined
            ? `staff/purchaseOrder/purchaseOrderProjects?searchKey=${searchKey}&page=${pageNo}`
            : `staff/purchaseOrder/purchaseOrderProjects?page=${pageNo}`;
    }

    const response = await axiosInstance.get(url);
    return response.data;
};

export const createProjectsApi = async (request) => {
    const response = await axiosInstance.post('staff/projects', request.formData);
    return response.data;
};

export const getOneProjectsApi = async (purchaseOrderNumber) => {
    const response = await axiosInstance.get(`staff/projects/${purchaseOrderNumber}`);
    return response.data;
};

export const updateProjectsApi = async (request) => {
    const response = await axiosInstance.put('staff/projects', request.formData);
    return response.data;
};
